/* global Eht */
import { Office } from '@bag'
import { validUtil } from '@/core'

const util = {
  table(opt) {
    const table = $(
      '<table cellspacing="0" cellpadding="0" border="1" class="file-table"></table>'
    )
    const colgroup = $('<colgroup></colgroup>')
    const cols = opt.cols
    cols.forEach(item => {
      const col = $(`<col width="${item}">`)
      colgroup.append(col)
    })
    table.append(colgroup)
    return table
  },
  title(opt, tar) {
    if (opt.title && Array.isArray(opt.title)) {
      const nodes = opt.title
        .map(t => {
          return `<div class="file-row__titles">${t}</div>`
        })
        .join('')
      return (nodes && $(nodes)) || ''
    }
  },
}

class OfficeGroup {
  constructor(opt) {
    const def = {
      selector: null,
      title: [], // 设置标题
      valueCodeField: 'f_code',
      labelCodeField: 'f_name',
      loadInit: true,
      codeContent: Eht.DataCode,
      hasOrder: true,
      atLast: 1, // 至少有几行
      header: null, // 头部
      headerRows: null, // 头部行
    }
    this.opt = Object.assign(def, opt)
    this.$el = $(this.opt.selector)
    this._bind = {}
    this.init()
  }

  init() {
    this.$el.addClass('lt-office office-group')
    this.groupList = []
    this.title = util.title(this.opt, this)
    if (this.opt.type === 'table') {
      this.table = util.table(this.opt)
      if (this.opt.header) {
        this.header = this.headAdd()
      }
      const content = $('<div class="file-content"></div>')
      this.title && content.prepend(this.title)
      content.append(this.table)
      this.$el.append(content)
    } else {
      this.title && this.$el.prepend(this.title)
    }
    const atLast = this.opt.atLast || 0
    for (let i = 0; i < atLast; i++) {
      this.groupAdd()
    }
  }

  bind(name, fn, event = 'click') {
    this.groupList.map(({ office }) => {
      const obj = office.objs[name]
      if (obj && $.type(obj.item[event]) === 'function') {
        obj.item[event](fn)
      }
    })
    if (!this._bind[name]) this._bind[name] = {}
    this._bind[name][event] = fn
  }

  headAdd() {
    const option = Object.assign({}, this.opt)
    option.type = 'thead'
    option.selector = this.opt.header
    option.rows = this.opt.headerRows || this.opt.rows
    const office = new Office(option)
    office.fill({})
    const unit = office.unit
    this.table.append(unit)
    const orderContent = this.creatOrder()
    if (this.opt.hasOrder) {
      const td = $('<th></th>')
      const cell = $('<div class="cell">序号</div>')
      td.append(cell)
      cell.append(orderContent)
      unit.find('tr').prepend(td)
    }
    return office
  }

  groupAdd(index) {
    const symbol = Math.round(Math.random() * Math.pow(10, 12))
    const option = Object.assign({}, this.opt, { symbol })
    if (option.type === 'table') option.type = 'tbody'
    const office = new Office(option)
    const unit = office.unit
    const objs = {}

    Object.entries(office.objs).map(x => {
      const bd = this._bind[x[0]]
      if (bd) {
        for (const event in bd) {
          const item = (objs[x[0]] = x[1].item)
          if (item[event] && $.type(item[event]) === 'function') {
            item[event](this._bind[x[0]][event])
            event === 'reset' && item[event]()
          }
        }
      }
    })
    const orderContent = this.creatOrder()
    if (this.opt.hasOrder) {
      if (option.type === 'tbody') {
        const td = $('<td></td>')
        const cell = $('<div class="cell"></div>')
        td.append(cell)
        cell.append(orderContent)
        unit.find('tr').prepend(td)
      } else {
        unit.prepend(orderContent)
      }
    }
    this.bindValid(this.opt.valid, office)
    const group = this.groupList
    const obj = { objs, unit, office, symbol, orderContent }
    if (index) {
      index = Number(index)
      group.some((item, i) => {
        if (item.symbol === index) {
          group.splice(i + 1, 0, obj)
          item.unit.after(unit)
          return true
        }
      })
    } else {
      group.push(obj)
      if (this.opt.type === 'table') {
        this.table.append(unit)
      } else {
        this.$el.append(unit)
      }
    }
    this.pushOrder()
    office.fill({})
    return office
  }

  pushOrder() {
    this.groupList.map(({ orderContent }, i) => {
      orderContent.text(i + 1)
    })
  }

  creatOrder() {
    return $('<div class="file-row__order"></div>')
  }

  groupDelete(index) {
    index = Number(index)
    this.groupList.some(item => {
      if (item.symbol === index) {
        if (this.groupList.length > this.opt.atLast) {
          item.office.destroy()
          const i = this.groupList.findIndex(it => item === it)
          this.groupList.splice(i, 1)
        } else {
          item.office.clearData()
        }
      }
    })
    this.pushOrder()
  }

  set valid(data) {
    this.opt.valid = data
    this.groupList.map(({ office }) => {
      this.bindValid(data, office)
    })
  }

  get valid() {
    return this.opt.valid
  }

  bindValid(data, office) {
    const valid = data
    const objs = office.objs
    if (valid) {
      for (const key in valid) {
        if (objs[key]) {
          objs[key].change(obj => {
            this.checkOneValid(obj, valid[key])
          })
          objs[key].keyup(obj => {
            this.checkOneValid(obj, valid[key])
          })
        }
      }
    }
  }

  checkOneValid(obj, vld) {
    const { rtn, text } = validUtil.getValidResult(obj, vld)
    this.touchValid(Boolean(rtn), text, obj)
  }

  getData() {
    return this.groupList.map(({ office }) => office.getData())
  }

  checkValid() {
    let res = true
    const valid = this.valid
    this.groupList.map(({ office }) => {
      const objs = office.objs
      if (valid) {
        for (const key in valid) {
          let nsk = true
          let textBuffer = ''
          if (objs[key]) {
            const vld = valid[key]
            const { rtn, text } = validUtil.getValidResult(objs[key], vld)
            nsk = rtn
            textBuffer = text
          }
          res = res & nsk
          this.touchValid(Boolean(nsk), textBuffer, objs[key])
        }
      }
    })

    return Boolean(res)
  }

  touchValid(res, text, obj) {
    obj.unit.find('.lt-tooltip').remove()
    if (!res) {
      obj.unit.addClass('is-error')
      obj.unit.append(`<div class="lt-tooltip">${text}</div>`)
    } else {
      obj.unit.removeClass('is-error')
    }
  }

  fill(data, ...res) {
    this.loadData(data, ...res)
  }

  clear(...res) {
    if (!res.length) {
      this.groupList
        .filter((item, i) => i >= this.opt.atLast * 1)
        .map(({ symbol }) => this.groupDelete(symbol))
    }
    this.groupList.map(({ office }, i) => {
      office.clearData(...res)
    })
  }

  loadData(args, ...res) {
    if (this._object == null) {
      this._object = args
    }
    if (args) {
      if ($.type(args) === 'object') {
        this.data = args.rows || []
      } else if ($.type(args) === 'array') {
        this.data = args
      } else if ($.type(args) === 'function') {
        this._loadData = args
        if (this.loadResp == null) {
          this.loadResp = new Eht.Responder()
          var error = this.loadResp.error
          this.loadResp.success = (data, textStatus, jqXHR) => {
            this.loadData(data, ...res)
            if (this._loadComplete != null) {
              this._loadComplete(data)
            }
          }
          this.loadResp.error = function (data, textStatus, jqXHR) {
            error(data, textStatus, jqXHR)
          }
        }
        if (this.opt.loadInit) {
          this._loadData(this.loadResp)
        }
        return
      }
      const group = this.groupList
      if ($.type(this.data) === 'array') {
        this.data.map((data, i) => {
          if (group[i]) {
            group[i].office.fill(data)
          } else {
            this.groupAdd()
            group[i].office.fill(data)
          }
        })
      }
    }
  }

  loadComplete(func) {
    this._loadComplete = func
  }

  refresh() {
    this.opt.loadInit = true
    this.loadData(this._object)
  }

  disabled(...res) {
    this.groupList.map(({ office }) => {
      office.disabledItem(...res)
    })
  }

  enabled(...res) {
    this.groupList.map(({ office }) => {
      office.enabledItem(...res)
    })
  }

  viewable(...res) {
    this.groupList.map(({ office }) => {
      office.viewable(...res)
    })
  }

  editable(...res) {
    this.groupList.map(({ office }) => {
      office.editable(...res)
    })
  }

  hideItem(...res) {
    this.groupList.map(({ office }) => {
      office.hideItem(...res)
    })
  }

  showItem(...res) {
    this.groupList.map(({ office }) => {
      office.showItem(...res)
    })
  }

  hideSection(...res) {
    this.groupList.map(({ office }) => {
      office.hideSection(...res)
    })
  }

  showSection(...res) {
    this.groupList.map(({ office }) => {
      office.showSection(...res)
    })
  }

  reset(...res) {
    this.groupList.map(({ office }) => {
      office.reset(...res)
    })
  }
}

Eht.OfficeGroup = OfficeGroup

export default OfficeGroup
